import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-content" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = { class: "flex dialog-detail align-items-center justify-content-between" }
const _hoisted_4 = { class: "flex dialog-detail align-items-center justify-content-between mt-s4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-form-icon" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pi pi-arrow-down" })
], -1)
const _hoisted_6 = { class: "dialog-data mt-s4" }
const _hoisted_7 = { class: "dialog-footer dialog-footer-two-btn" }

import SwapInfo from '@/views/pages/swap/components/SwapInfo.vue';
import { useSwap } from '@/store/modules/swap/useSwap';
import { TokenAmount } from '@/sdk/entities/fractions/tokenAmount';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { safeParseUnits } from '@/helpers/utils';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Confirmation',
  props: {
    inProgress: { type: Boolean },
    cancel: null,
    confirm: null
  },
  setup(__props: any) {



const { t } = useI18n();
const { swapForm } = useSwap();
const amountStrToSignificant = (token, amount) => {
  return new TokenAmount(token, safeParseUnits(amount, token.decimals)).toSignificant(8);
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(TokenIcon, {
            "icon-src": _unref(swapForm).input.token?.tokenIconUrl,
            symbol: _unref(swapForm).input.token?.symbol,
            "chain-id": _unref(swapForm).input.token?.chainId,
            size: "20",
            full: ""
          }, null, 8, ["icon-src", "symbol", "chain-id"]),
          _createElementVNode("span", null, _toDisplayString(amountStrToSignificant(_unref(swapForm).input.token, _unref(swapForm).input.amount)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TokenIcon, {
            "icon-src": _unref(swapForm).output.token?.tokenIconUrl,
            symbol: _unref(swapForm).output.token?.symbol,
            "chain-id": _unref(swapForm).output.token?.chainId,
            size: "20",
            full: ""
          }, null, 8, ["icon-src", "symbol", "chain-id"]),
          _createElementVNode("span", null, _toDisplayString(amountStrToSignificant(_unref(swapForm).output.token, _unref(swapForm).output.amount)), 1)
        ]),
        _hoisted_5
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(SwapInfo, { "is-dialog": true })
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: _unref(t)('cancel'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.cancel()))
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: _unref(t)('swap.confirmDialog.confirmBtn'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.confirm()))
      }, null, 8, ["label"])
    ])
  ], 64))
}
}

})